import { Heading } from '@purpur/library';
import styled, { css } from 'styled-components';

import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
} from '@telialt/common-theme/src/purpurSelectors';

import { ProductOverview } from '../ProductOverview/ProductOverview';
import { ProductOverviewTitle } from '../ProductOverview/ProductOverview.styles';

export const GiftTitle = styled(Heading)`
    margin-top: ${getPurpurSpacing('600')};
    margin-bottom: ${getPurpurSpacing('300')};
`;

export const GiftPriceContainer = styled.div`
    margin-top: ${getPurpurSpacing('300')};
    margin-bottom: ${getPurpurSpacing('600')};
`;

export const GiftOldPrice = styled.span`
    text-decoration: line-through;
    margin-right: ${getPurpurSpacing('100')};
`;

export const GiftNewPrice = styled.span`
    font-size: ${getPurpurTypography('scale600')};
`;

const showMoreOrLessBorderHidingHack = css`
    position: relative;
    &::after {
        content: '';
        display: block;
        height: ${getPurpurBorder('widthSm')};
        width: 100%;
        position: absolute;
        bottom: 0;
        background: ${getPurpurColor('backgroundPrimary')};
    }
`;

export const GiftDescriptionSection = styled(ProductOverview).attrs({ technicalCharacteristicsAlignment: '2-columns' })`
    border-top: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('gray200')};
    margin-top: ${getPurpurSpacing('600')};
    ${showMoreOrLessBorderHidingHack}

    ${ProductOverviewTitle} {
        margin-top: ${getPurpurSpacing('600')};
        font-size: ${getPurpurTypography('scale400')};
    }
`;
